module.exports = "## Compress PDF Online\n\nOur PDF compressor is 100% free and it operates entirely on the cloud. This means you do not need to install any software to compress your PDF files. Whether you are looking for a PDF compressor for mac, windows, or mobile devices, this tool can make your pdf smaller. We also remove all PDF files from our servers after 12 hours for security and privacy."


//////////////////
// WEBPACK FOOTER
// ./src/containers/PdfCompressor/compress-pdf-online.md
// module id = 1183
// module chunks = 0